'use strict';
import { j as r } from "../../external/react/jsx-runtime.js";
import t from "react";
import e from "./bread-crumbs.module.scss.js";
import { removeHyphen as m } from "../../helpers/stringUtils.js";
const o = (l) => /* @__PURE__ */ r.jsx("nav", { className: e.wrapper, children: l.list.map((s, a) => a + 1 === l.list.length ? /* @__PURE__ */ r.jsx(
  "span",
  {
    className: e["breadcrumbs--bold"],
    children: /* @__PURE__ */ r.jsx("a", { href: `${s.url}`, children: m(s.title) })
  },
  a
) : /* @__PURE__ */ r.jsxs(t.Fragment, { children: [
  /* @__PURE__ */ r.jsx("span", { className: e.breadcrumbs, children: /* @__PURE__ */ r.jsx("a", { href: `${s.url}`, children: s.title }) }),
  /* @__PURE__ */ r.jsx("span", { className: e.breadcrumbs, children: " / " })
] }, a)) });
export {
  o as default
};
